import { render, staticRenderFns } from "./PayrollDetailsModel.vue?vue&type=template&id=baae9594&scoped=true&"
import script from "./PayrollDetailsModel.vue?vue&type=script&lang=js&"
export * from "./PayrollDetailsModel.vue?vue&type=script&lang=js&"
import style0 from "./PayrollDetailsModel.vue?vue&type=style&index=0&id=baae9594&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baae9594",
  null
  
)

export default component.exports